import { useState, useEffect } from 'react';
import { adminProductsAPI } from './adminApi';
import s from './AdminPending.module.css';

export default function AdminPending() {
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [acting,   setActing]   = useState(null);
  const [declineId, setDeclineId] = useState(null);
  const [reason,   setReason]   = useState('');

  useEffect(() => {
    adminProductsAPI.pending()
      .then(res => setProducts(res.data.products || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const approve = async (id) => {
    setActing(id);
    try {
      await adminProductsAPI.approve(id);
      setProducts(prev => prev.filter(p => p.id !== id));
    } catch { alert('Failed'); }
    finally { setActing(null); }
  };

  const decline = async (id) => {
    setActing(id);
    try {
      await adminProductsAPI.decline(id, reason);
      setProducts(prev => prev.filter(p => p.id !== id));
      setDeclineId(null); setReason('');
    } catch { alert('Failed'); }
    finally { setActing(null); }
  };

  if (loading) return <div className={s.loading}><div className={s.spin} /></div>;

  return (
    <div className={s.page}>
      <div className={s.header}>
        <h1 className={s.title}>Pending Review</h1>
        <p className={s.sub}>{products.length} product{products.length !== 1 ? 's' : ''} waiting</p>
      </div>

      {products.length === 0 ? (
        <div className={s.empty}><span>✅</span><p>All caught up — no pending products</p></div>
      ) : (
        <div className={s.grid}>
          {products.map(p => (
            <div key={p.id} className={s.card}>
              {p.image_url
                ? <img src={p.image_url} alt={p.name} className={s.img} />
                : <div className={s.imgph}>📦</div>
              }
              <div className={s.info}>
                <div className={s.meta}>
                  <span className={s.cat}>{p.category}</span>
                  <span className={s.code}>{p.productCode || `#${p.id}`}</span>
                </div>
                <h3 className={s.name}>{p.name}</h3>
                <p className={s.desc}>{p.description}</p>
                <div className={s.footer}>
                  <p className={s.price}>₦{Number(p.price).toLocaleString()}</p>
                  <p className={s.seller}>by {p.seller_name}</p>
                </div>

                {declineId === p.id ? (
                  <div className={s.declineForm}>
                    <textarea className={s.reasonInput} placeholder="Reason for declining…" value={reason} onChange={e => setReason(e.target.value)} rows={2} />
                    <div className={s.declineBtns}>
                      <button className={s.cancelBtn} onClick={() => { setDeclineId(null); setReason(''); }}>Cancel</button>
                      <button className={s.confirmDeclineBtn} onClick={() => decline(p.id)} disabled={acting === p.id || !reason.trim()}>
                        {acting === p.id ? '…' : 'Confirm'}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className={s.actions}>
                    <button className={s.approveBtn} onClick={() => approve(p.id)} disabled={acting === p.id}>
                      {acting === p.id ? '…' : '✅ Approve'}
                    </button>
                    <button className={s.declineBtn} onClick={() => setDeclineId(p.id)}>❌ Decline</button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
